import { render, staticRenderFns } from "./PersonnelCategorical.vue?vue&type=template&id=c4549560"
import script from "./PersonnelCategorical.vue?vue&type=script&lang=js"
export * from "./PersonnelCategorical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports